import { MatSlider } from "@angular/material";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, OnDestroy } from "@angular/core";
import { CoreLanguageService } from "../../services/language.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLogService } from "../../services/log.service";
import { WebShopService } from "../../services/webShop.service";
import { InhousePaymentOrderService } from "./inHousePaymentOrder.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { ItemNotAvaliableDialogComponent, WarningdialogComponent, AnnounceDialogComponent } from "../../modalDialogs";
import { AnnounceDialogModalData } from "../../modalDialogs/announceDialog/announceDialog.component";
import { Observable, Subscription } from "rxjs";
import { ISeatOrder, IItemSortOption, ISeatOrderItem } from "./inHousePaymentOrder.facade";
import { IOSHelperService } from "../../services/IOSHelper.service";
import Utils from "../../shared/utils";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { AnounceModalResult, SnackBarMessageType } from "../../shared/contentTypes";
import { InHouseOrderService } from "../../services/inHouseOrder.service";

/** Zeit bis durch inaktivität die Bestellung abgebrochen wird */
const IDLE_ORDER_TIMEOUT = 60 * 1000; // 60sec

@Component({
  selector: "ya-inhouse-payment-order",
  templateUrl: "./inHousePaymentOrder.component.html",
  styleUrls: ["./inHousePaymentOrder.component.scss"],
  providers: [InhousePaymentOrderService, OverlaySpinnerService],
  animations: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class InHousePaymentOrderComponent implements OnInit, OnDestroy {
  @ViewChild("tipSlider", { read: MatSlider }) tipSlider: MatSlider;

  @Output() onContinue = new EventEmitter(); // TODO Momentan nur um vorherige Funktionalität zu erhalten.

  public isSmallView: boolean;
  public currencySymbol: string;
  public tipSliderValue: number;
  public tipInputValue: string;
  public selectOptionsShown: boolean = false;
  public canSelect$: Observable<boolean>;
  public tableNo$: Observable<string>;
  public orders$: Observable<ReadonlyArray<ISeatOrder>>;
  public sum$: Observable<number>; // Summe der gewählten Items
  public showTipping: boolean; // Ob Trinkgeld angeboten wird oder nicht.
  public tippingPercent$: Observable<number>; // sum + Trinkgeld
  public tippingAmount$: Observable<number>; // sum + Trinkgeld
  public total$: Observable<number>; // sum + tippingAmount
  public sortOptions$: Observable<ReadonlyArray<IItemSortOption>>;
  public canContinue$: Observable<boolean>;

  private _localeChangeSubscription: Subscription;
  private _isTableCloseDialogOpen = false;
  private _isContinueInFlight = false;

  constructor(
    private _inHousePaymentOrderService: InhousePaymentOrderService,
    private _coreLanguageService: CoreLanguageService,
    private _internationalisationService: InternationalisationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _iosHelperService: IOSHelperService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _snackBarService: SnackBarService,
    private _inHouseOrderService: InHouseOrderService,
    webShopService: WebShopService, // Nur für Currencysymbol im Moment
    mainnavService: MainnavService,
  ) {
    const me = this;
    me.isSmallView = mainnavService.viewType === ViewType.Small;
    me.currencySymbol = webShopService.currencySymbol || "€";
    me.tipSliderValue = 0;
    me.tipInputValue = me.formatCurrency(0, false); // en/de delimiter setzen

    me.tableNo$ = me._inHousePaymentOrderService.tableNo$;
    me.orders$ = me._inHousePaymentOrderService.orders$;
    me.sum$ = me._inHousePaymentOrderService.sum$;
    me.showTipping = me._inHousePaymentOrderService.showTipping;
    me.total$ = me._inHousePaymentOrderService.total$;
    me.sortOptions$ = me._inHousePaymentOrderService.sortOptions$;
    me.canContinue$ = me._inHousePaymentOrderService.canContinue$;
  }

  ngOnInit() {
    const me = this;
    // ? Was und warum ist das hier.
    setTimeout(() => {
      if (me.tipSlider) {
        me.tipSlider._onClick = (e) => e.preventDefault();
      }
    }, 700);

    me._localeChangeSubscription = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._inHousePaymentOrderService.tippingPercent$.subscribe((newTipPrecent) => {
      me.tipSliderValue = newTipPrecent;
    });

    me._inHousePaymentOrderService.tippingAmount$.subscribe((newTipAmount) => {
      me.tipInputValue = me.formatCurrency(newTipAmount, false);
    });

    me._inHousePaymentOrderService.activityTriggerd$.subscribe(() => {
      me.resertIdleOrderTimeout();
    });

    me._overlaySpinnerService.ShowLayoutSpinner();
    me._inHousePaymentOrderService.startPaymentSelect().then((success) => {
      me._overlaySpinnerService.HideLayoutSpinner();
      if (success) {
        me.resertIdleOrderTimeout();
      } else {
        me._snackBarService.ShowErrorMessageFailed(48);
        me._inHouseOrderService.openInHauseLandingPage(); // no wait need
      }
    }).catch(() => {
      me._overlaySpinnerService.HideLayoutSpinner();
    })

    me.PushChanges();
  }

  ngOnDestroy() {
    const me = this;
    if (me.idleOrderTimeout)
      clearTimeout(me.idleOrderTimeout);
    if (me._localeChangeSubscription)
      me._localeChangeSubscription.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("InHauseServicePaymentComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  selectAll() {
    this._inHousePaymentOrderService.selectAll();
  }
  selectNone() {
    this._inHousePaymentOrderService.selectNone();
  }
  selectMyItems() {
    this._inHousePaymentOrderService.selectMyItems();
  }
  setTippingPercent(percent: number) {
    this._inHousePaymentOrderService.setTippingPercent(percent);
  }
  setTippingAmount(amount: number) {
    this._inHousePaymentOrderService.setTippingAmount(amount);
  }

  /**
   * Resolves to true if payment should proceed, false if the user cancelled.
   *
   * Falls back to showing the dialog when table data is unavailable.
   */
  private async checkTableCloseWarningBeforePayment(): Promise<boolean> {
    const me = this;
    if (me.isGroupOrder) {
      return true;
    }
    let showDialog: boolean;
    try {
      const table = await me._inHouseOrderService.GetTable(null);
      showDialog = me._inHousePaymentOrderService.paymentClosesTableForOthers(table, me._inHouseOrderService.UserToken);
    } catch {
      showDialog = true;
    }
    if (!showDialog) {
      return true;
    }
    if (me._isTableCloseDialogOpen) {
      return Promise.resolve(false);
    }
    me._isTableCloseDialogOpen = true;
    return new Promise<boolean>((resolve) => {
      try {
        const dialogRef = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
          data: {
            title: "phInHouseTableClose_Title",
            content: "phInHouseTableClose_Content",
            firstBtnLabel: "phInHouseTableClose_Btn_Confirm",
            secondBtnLabel: "phInHouseTableClose_Btn_Cancel",
          } as AnnounceDialogModalData,
          panelClass: "mat-bottom-sheet-container-medium",
        });
        dialogRef.afterDismissed().subscribe((result: AnounceModalResult) => {
          me._isTableCloseDialogOpen = false;
          resolve(result === AnounceModalResult.FirstButton);
        });
      } catch (err) {
        me._isTableCloseDialogOpen = false;
        me._coreLogService.error("InHousePaymentOrderComponent.checkTableCloseWarningBeforePayment", "dialog open failed", err);
        resolve(false);
      }
    });
  }

  /** Advances to checkout, confirming the table-close warning first when applicable. */
  async continue() {
    const me = this;
    if (me._isContinueInFlight) { return; }
    me._isContinueInFlight = true;
    try {
      const shouldProceed = await me.checkTableCloseWarningBeforePayment();
      if (!shouldProceed) {
        me._inHouseOrderService.openInHauseLandingPage();
        return;
      }
      if (me.idleOrderTimeout)
        clearTimeout(me.idleOrderTimeout);
      me._inHousePaymentOrderService.continue();
      me.onContinue.emit();
    } finally {
      me._isContinueInFlight = false;
    }
  }

  /** ngFor trackBy Functions */
  public trackSeatOrderBy(seatOrder: ISeatOrder) {
    return seatOrder.id;
  }

  public trackSeatOrderItemBy(seatOrderItem: ISeatOrderItem) {
    return seatOrderItem.id;
  }

  public showSelectOptions() {
    const me = this;
    me.selectOptionsShown = !me.selectOptionsShown;
  }

  public get groupName(): string {
    return this._inHousePaymentOrderService.groupName;
  }
  public get isGroupOrder(): boolean {
    return !Utils.IsNullOrEmpty(this.groupName);
  }

  /**Item can not be paid */
  public NotAvaliableDialog(orderOrItem: ISeatOrder | ISeatOrderItem) {
    const me = this;
    if (orderOrItem.isLockedForPayment) {
      me._bottomSheetHelperService.open(ItemNotAvaliableDialogComponent, {
        data: {
          title: "phInHouse_Item_Not_Avaliable_Header",
          description: "phInHouse_Item_Not_Avaliable_Subtext",
          buttonText: "phInHouse_Item_Not_Avaliable_Btn",
        },
        panelClass: "mat-bottom-sheet-container-medium"
      });
    }
  }

  /** Cache für Timeout bei inaktivität währen der Auswahl */
  private idleOrderTimeout: NodeJS.Timer = null;

  /** Aktualisiert nach einer Action den Timer um bei inaktivität die Auswahl abzubrechen */
  private resertIdleOrderTimeout(): void {
    const me = this;
    clearTimeout(me.idleOrderTimeout);
    me.idleOrderTimeout = setTimeout(() => {
      me.idleOrderTimeout = null;
      // Abbruch + Dialog anzeigen und umleiten auf Landingpage
      me._inHousePaymentOrderService.abortPaymentSelect(); // no wait need
      me.OpenStillThereDialog(); // no wait need
      me._inHouseOrderService.openInHauseLandingPage(); // no wait need
    }, IDLE_ORDER_TIMEOUT);
  }

  /** Warning dialog: inactivity in the payment process/item selection */
  private OpenStillThereDialog() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_Still_There_Title"
        , content: "phInHouse_Still_There_Description"
        , btnLabel: "phInHouse_Continue_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  public formatCurrency(price: number, hasSymbol: boolean = true): string {
    return Utils.currencyFormatter(price, this.currencySymbol, hasSymbol, true);
  }

  public SetUserPlace(userPlace: number) {
    const me = this;
    return me._coreLanguageService.value("phInHouse_Payment_User_Place")
      .replace("{placeNo}", userPlace.toString());
  }

  // set tip value by changing slider value
  public onSliderValueChange() {
    const me = this;
    const newPercentage = me.tipSliderValue;
    me._inHousePaymentOrderService.setTippingPercent(newPercentage);
  }

  // set tip value by changing input value
  public onInputTrinkgeldChange() {
    const me = this;
    const newAmount = +(me.tipInputValue.replace(",", "."));
    me._inHousePaymentOrderService.setTippingAmount(newAmount);
  }

  // Used by Slider
  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  // Format slider label
  formatTipSliderLabel(value: number | null) {
    if (!value || value === 0) {
      return 0 + " %";
    }
    return value + " %";
  }
}
